import React from 'react';

const FormError = ({ text }) => (
  <span className="text-red-500 text-sm">{text}</span>
);

export default FormError;
